import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FlatButton from 'material-ui/FlatButton';
import { reduxForm, Field, submit } from 'redux-form/immutable';
import { TextField } from 'redux-form-material-ui';
import { fromJS } from 'immutable';

import FireBaseTools, { firebaseStorage, getTenantPath } from '../../../utils/firebase';
import { toJSSafe } from '../../../utils/helper';

import { updateUser, updateUserEmail } from '../../../actions/firebase';
import {
  setImage,
  setImageDownloadUrl } from '../../../actions/employees';
import { hideDialog } from '../../../actions/dialogs';
import ReduxDialog from '../../Common/ReduxDialog';
import ImageUpload from '../../Common/ImageUpload';

import commonStyles from '../../styles';
import styles from './styles';

class UserProfile extends Component {
  static propTypes = {
    updateUser: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    currentUser: PropTypes.object.isRequired,
    setImage: PropTypes.func.isRequired,
    employee: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    // this.props.fetchUser();
    this.state = {
      message: '',
    };
  }

  handleImageUpload = (image, data) => {
    FireBaseTools.uploadEmployeeImage(image, data);
    this.props.setImage(null, image);
  };

  render() {
    const actions = [
      <FlatButton
        label="Cancel"
        primary
        onClick={() => this.props.hideDialog('profile')}
      />,
      <FlatButton
        label="Save"
        primary
        keyboardFocused
        onClick={() => this.props.dispatch(submit('Profile'))}
      />,
    ];

    return (
      <ReduxDialog
        name="profile"
        title={`Profile  ${this.props.currentUser.displayName ? this.props.currentUser.displayName : this.props.currentUser.email}`}
        actions={actions}
        modal={false}
        onRequestClose={() => this.props.hideDialog('profile')}
      >
        <form name="customer">
          { this.state.message ? <p>{this.state.message}</p> : null }
          <div style={styles.row}>
            <div style={styles.profile}>
              <ImageUpload
                type="userProfile"
                src={this.props.employee.imageUrl ? this.props.employee.imageUrl : this.props.currentUser.photoURL}
                height={300}
                width={300}
                onUpload={this.handleImageUpload}
              />
            </div>
            <div style={styles.main}>
              <div style={styles.row}>
                <Field
                  name="firstName"
                  component={TextField}
                  floatingLabelText="First Name"
                  floatingLabelFixed
                  fullWidth
                  disabled
                  value={this.state.firstName}
                  style={commonStyles.input}
                />
                <Field
                  name="lastName"
                  component={TextField}
                  floatingLabelText="Last Name"
                  floatingLabelFixed
                  fullWidth
                  disabled
                  value={this.state.lastName}
                  style={commonStyles.input}
                />
              </div>
              <div className="form-group">
                <Field
                  name="email"
                  component={TextField}
                  floatingLabelText="Email"
                  floatingLabelFixed
                  fullWidth
                  style={commonStyles.input}
                />
              </div>
              <div className="form-group">
                <Field
                  name="displayName"
                  component={TextField}
                  floatingLabelText="Display Name"
                  floatingLabelFixed
                  fullWidth
                  defaultValue={this.props.currentUser.displayName}
                  style={commonStyles.input}
                />
              </div>
            </div>
          </div>
        </form>
        {/* <ChangePassword />*/}
      </ReduxDialog>
    );
  }
}

const form = reduxForm({
  form: 'Profile',  // a unique identifier for this form
  enableReinitialize: true,
  onSubmit: (values, dispatch, props) => {
    const payload = values.toJS();
    if (props.employee.image) {
      firebaseStorage.ref(getTenantPath(`/employees/${props.employee.image}`)).getDownloadURL().then((image) => {
        props.setImageDownloadUrl(image);
        const profileDetail = {
          displayName: payload.displayName,
          photoURL: image,
        };
        props.updateUser(profileDetail);
      });
    } else if (props.currentUser.displayName !== payload.displayName) {
      props.updateUser({ displayName: payload.displayName });
    }
    if (props.currentUser.email !== payload.email) {
      props.updateUserEmail(payload.email);
    }
    props.hideDialog('profile');
  },
})(UserProfile);

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    // fetchUser,
    updateUser,
    updateUserEmail,
    hideDialog,
    setImage,
    setImageDownloadUrl,
  }, dispatch);
}

function mapStateToProps(state) {
  const user = toJSSafe(state.get('authentication').get('user'));
  return {
    currentUser: user,
    initialValues: fromJS(user),
    employee: state.get('employees').get('employee').toJS(),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Authentication/Profile/index.js